import Vue from 'vue'
import {
  Dialog,
  Icon,
  Toast,
  Swipe, SwipeItem,
  Popup
} from 'vant'

Vue.use(Popup)
Vue.use(Swipe).use(SwipeItem)
Vue.use(Toast)
Vue.use(Icon)
Vue.use(Dialog)



// WEBPACK FOOTER //
// ./src/ui/vant-ui.js